<template>
	<v-col class="purchase-product">
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Belanja Produk</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-cart</v-icon>
			<div class="pl-2">Transaksi Produk</div>
			<div class="px-2">/</div>
			<div>Belanja Produk</div>
		</div>
		<div class="mt-5">
			<Mitra></Mitra>
		</div>
	</v-col>
</template>

<script>
import { mapState } from 'vuex'
import Mitra from './components/Mitra';

export default {
	components: {
		Mitra
	},
	data() {
		return {
		}
	},
	computed: {
		...mapState('auth', ['userData']),
	},
	methods: {
	},
	created(){
		this.$store.dispatch('setPageTitle', `Belanja Produk`)
	},
};
</script>
